import { render, staticRenderFns } from "./Cuentas.vue?vue&type=template&id=1c08fcc2&scoped=true"
import script from "./Cuentas.vue?vue&type=script&lang=js"
export * from "./Cuentas.vue?vue&type=script&lang=js"
import style0 from "./Cuentas.vue?vue&type=style&index=0&id=1c08fcc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c08fcc2",
  null
  
)

export default component.exports